import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import Isvg from 'react-inlinesvg'

import './Navbar.scss'
import logo from '../../sass/images/logo.svg'
import iconPerson from '../../sass/icons/icon-person.svg'

class Navbar extends Component {

  state = {
    open: false,
    navbarUp: false,
    slide: 0,
    lastScrollY: 0
  }

  static contextTypes = {
    t: PropTypes.func.isRequired
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.open === true) {
      document.body.classList.toggle('navbar-open')
    } else {
      setTimeout(function () { document.body.classList.remove('navbar-open') }, 250);
    }
  }

  handleScroll = () => {
    const { lastScrollY } = this.state;
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY) {
      this.setState({
        slide: '-250px',
        navbarUp: false
      });
    } else {
      this.setState({
        slide: 0,
        navbarUp: true
      });
    }
    this.setState({ lastScrollY: currentScrollY });
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  render() {
    return (
      <nav className={this.state.navbarUp ? "navbar navbar-up" : "navbar"} style={{
        top: `${this.state.slide}`
      }}>
        <div className="login-nav">
          <div className="container">
            <div className="grid-right">
              <a href="https://app.talkative.media/" rel="noopener noreferrer" target="_blank" className="login hide-mobile" >
                <Isvg src={iconPerson} />
                {this.context.t('Entrar')}
              </a>
            </div>
          </div>
        </div>
        <div className="main-nav">
          <div className={`container navbar-nav`}>
            <div className="grid-spaceBetween">
              <div className="col-2_md-2_sm-12 site-logo">
                <a href="https://app.talkative.media/" rel="noopener noreferrer" target="_blank" className="login hide-desktop" >
                  <Isvg src={iconPerson} />
                </a>
                <Link to={'/'}>
                  <Isvg src={logo} />
                </Link>
                <div className={`nav-toggle hide-desktop ${this.state.open ? 'open' : ''}`} onClick={() => this.setState({ open: !this.state.open } )}>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className={`col-10_md-10_sm-12 navbar-links grid middle ${this.state.open ? 'show' :''}`}>
                <Link to={this.context.t('/pequeno-negocio', {}, 'Rota para /pequeno-negocio')}>
                  {this.context.t('Para pequeno negócio', {}, 'Texto no rodapé')}
                </Link>
                <Link to={this.context.t('/grande-empresa', {}, 'Rota para /grande-empresa')}>
                  {this.context.t('Para grande empresa', {}, 'Texto no rodapé')}
                </Link>
                <Link to={this.context.t('/politica', {}, 'Rota para /politica')}>
                  {this.context.t('Para políticos', {}, 'Texto no rodapé')}
                </Link>
                <Link to={this.context.t('/artigos', {}, 'Rota para /artigos')}>
                    {this.context.t('Artigos')}
                </Link>
                {/* <Link to={this.context.t('/personalidade', {}, 'Rota para /personalidade')}>
                  {this.context.t('Para personalidades', {}, 'Texto no rodapé')}
                </Link>
                <Link to={this.context.t('/endomarketing', {}, 'Rota para /endomarketing')}>
                  {this.context.t('Para endomarketing', {}, 'Texto no rodapé')}
                </Link>
                <Link to={this.context.t('/causa', {}, 'Rota para /causa')}>
                  {this.context.t('Para causas', {}, 'Texto no rodapé')}
                </Link>
                <Link to={this.context.t('/checkout', {}, 'Rota para /checkout')}>
                    {this.context.t('Planos')}
                </Link>
                <Link className="btn-nav" to={this.context.t('/checkout', {}, 'Rota para /checkout')}>
                  {this.context.t('Teste grátis', {}, 'Nome do botão para /checkout/light')}
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js